<div class="menu-filtro panel-heading-container" *ngFor="let item of menu">
  <div
    class="panel-heading-container"
    *ngIf="item.children.length; else elseBlockNotHasChildren"
  >
    <a
      data-toggle="collapse"
      class="panel-heading btn-panel {{ item.selected ? '' : 'collapsed' }}"
      (click)="item.selected = !item.selected"
    >
      <div class="desc" (click)="onClick(item.description, item)">
        {{ item.description }}
      </div>
    </a>
    <div
      id="box{{ item.id }}"
      class="dropdown-box list-group list-group-flush panel-collapse collapse {{
        item.selected ? 'show' : ''
      }}"
    >
      <app-catalog-menu-click
        #submenu
        (onSelect)="onSelect($event)"
        *ngFor="let subItem of item.children"
        [item]="subItem"
        [selected]="subItem.selected"
        [parent]="item.description"
        (breadCrumb)="saveBc($event)"
      ></app-catalog-menu-click>
    </div>
  </div>

  <ng-template #elseBlockNotHasChildren>
    <a
      (click)="onClick(item.description, item)"
      style="cursor: pointer"
      class="panel-heading-no-subtitle"
      >{{ item.description }}</a
    >
  </ng-template>
</div>

<hr *ngIf="menu" />
